(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moab-editorial-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('moab-cinema-hero-v6')) {
  customElements.define('moab-cinema-hero-v6', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mchReady === 'true') return;
      this.dataset.mchReady = 'true';

      const slides = [...this.querySelectorAll('[data-slide]')];
      if (!slides.length) return;

      const tracks = [...this.querySelectorAll('[data-goto]')];
      const counter = this.querySelector('[data-current]');
      const announcement = this.querySelector('[data-announcement]');
      const events = new AbortController();

      const on = (el, name, fn, options = {}) => {
        el?.addEventListener(name, fn, {
          ...options,
          signal: events.signal
        });
      };

      let index = Math.max(
        0,
        slides.findIndex(slide => slide.classList.contains('is-active'))
      );

      const interval = Math.max(
        3000,
        Number(this.dataset.interval) || 3000
      );

      let visible = true;
      let holding = false;
      let holdStart = 0;
      let suppressNextClick = false;

      let elapsed = 0;
      let lastTime = null;
      let raf = null;

      const HOLD_THRESHOLD = 220;

      const canRun = () =>
        slides.length > 1 &&
        visible &&
        !document.hidden &&
        !holding;

      const paintProgress = ratio => {
        tracks.forEach((track, i) => {
          const fill = track.querySelector('span');
          if (!fill) return;

          const clamped = Math.max(0, Math.min(1, ratio));
          const visibleRatio =
            1 - Math.pow(1 - clamped, 1.45);

          fill.style.transform =
            i === index
              ? `translateY(-50%) scaleX(${visibleRatio})`
              : 'translateY(-50%) scaleX(0)';
        });
      };

      const stopClock = () => {
        if (raf !== null) {
          cancelAnimationFrame(raf);
          raf = null;
        }

        /* elapsed korunur: bırakınca kaldığı yerden devam eder. */
        lastTime = null;
      };

      const tick = time => {
        if (!canRun()) {
          stopClock();
          return;
        }

        if (lastTime === null) {
          lastTime = time;
        }

        elapsed += time - lastTime;
        lastTime = time;

        const ratio = elapsed / interval;
        paintProgress(ratio);

        if (ratio >= 1) {
          show(index + 1, false);
          return;
        }

        raf = requestAnimationFrame(tick);
      };

      const startClock = () => {
        if (raf !== null || !canRun()) return;
        lastTime = null;
        raf = requestAnimationFrame(tick);
      };

      const resetClock = () => {
        stopClock();
        elapsed = 0;
        lastTime = null;
        paintProgress(0);
      };

      const show = (next, manual = true) => {
        const previous = slides[index];
        index = (next + slides.length) % slides.length;

        if (
          manual &&
          previous?.contains(document.activeElement)
        ) {
          this.querySelector('[data-next]')?.focus();
        }

        slides.forEach((slide, i) => {
          const active = i === index;

          slide.classList.toggle('is-active', active);
          slide.inert = !active;
          slide.setAttribute(
            'aria-hidden',
            String(!active)
          );

          if (active) {
            slide
              .querySelector('img')
              ?.setAttribute('loading', 'eager');
          }
        });

        tracks.forEach((track, i) => {
          if (i === index) {
            track.setAttribute(
              'aria-current',
              'true'
            );
          } else {
            track.removeAttribute(
              'aria-current'
            );
          }
        });

        if (counter) {
          counter.textContent =
            String(index + 1).padStart(2, '0');
        }

        if (manual && announcement) {
          announcement.textContent =
            `${index + 1} / ${slides.length}: ` +
            `${slides[index]
              .querySelector('.mch__title')
              ?.textContent.trim() || ''}`;
        }

        resetClock();
        startClock();
      };

      const goToSlideLink = slide => {
        const url = slide?.dataset.slideLink;
        if (url) window.location.href = url;
      };

      /* ==================================================
         NORMAL CLICK
         Kısa tık = slayt linki.
         Uzun basma sonrası oluşan click = iptal.
      ================================================== */
      on(this, 'click', event => {
        const button =
          event.target.closest('button');

        if (button && this.contains(button)) {
          if (button.hasAttribute('data-next')) {
            show(index + 1);
          }

          if (button.hasAttribute('data-prev')) {
            show(index - 1);
          }

          if (button.hasAttribute('data-goto')) {
            show(Number(button.dataset.goto));
          }

          return;
        }

        /* CTA kendi href davranışını kullansın. */
        if (event.target.closest('a')) return;

        const slide =
          event.target.closest('[data-slide]');

        /*
          Görsel / picture / media alanına kısa tık:
          slayta atanmış bağlantıya direkt gider.
          Basılı tutma sonrası suppressNextClick yine korunur.
        */

        if (
          !slide ||
          !slide.classList.contains('is-active')
        ) {
          return;
        }

        if (suppressNextClick) {
          suppressNextClick = false;
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        goToSlideLink(slide);
      });

      /* ==================================================
         HOLD TO PAUSE
         Pointer down = progress/geçiş donar.
         Pointer up = aynı noktadan devam.
      ================================================== */
      on(this, 'pointerdown', event => {
        if (
          event.pointerType === 'mouse' &&
          event.button !== 0
        ) {
          return;
        }

        if (event.target.closest('a,button')) {
          return;
        }

        const slide =
          event.target.closest('[data-slide]');

        if (
          !slide ||
          !slide.classList.contains('is-active')
        ) {
          return;
        }

        holding = true;
        holdStart = performance.now();
        suppressNextClick = false;

        stopClock();
        this.classList.add('is-holding');

        try {
          slide.setPointerCapture(
            event.pointerId
          );
        } catch (_) {}
      });

      const releaseHold = () => {
        if (!holding) return;

        const heldFor =
          performance.now() - holdStart;

        holding = false;
        this.classList.remove('is-holding');

        if (heldFor >= HOLD_THRESHOLD) {
          suppressNextClick = true;
        }

        startClock();
      };

      on(this, 'pointerup', releaseHold);
      on(this, 'pointercancel', releaseHold);

      /* Pencere odağı giderse slider kilitli kalmasın. */
      on(window, 'blur', () => {
        if (!holding) return;
        holding = false;
        this.classList.remove('is-holding');
        startClock();
      });

      /* ==================================================
         KEYBOARD
      ================================================== */
      on(this, 'keydown', event => {
        if (
          /INPUT|TEXTAREA|SELECT/.test(
            event.target.tagName
          )
        ) {
          return;
        }

        if (event.key === 'Enter') {
          const slide =
            event.target.closest('[data-slide]');

          if (
            slide?.classList.contains('is-active') &&
            slide.dataset.slideLink
          ) {
            event.preventDefault();
            goToSlideLink(slide);
            return;
          }
        }

        if (
          !['ArrowLeft', 'ArrowRight']
            .includes(event.key)
        ) {
          return;
        }

        event.preventDefault();

        show(
          index +
          (event.key === 'ArrowRight' ? 1 : -1)
        );
      });

      /* ==================================================
         MOBILE SWIPE
      ================================================== */
      let touch = null;

      on(this, 'touchstart', event => {
        if (
          event.touches.length !== 1 ||
          event.target.closest('a,button')
        ) {
          touch = null;
          return;
        }

        touch = {
          x: event.touches[0].clientX,
          y: event.touches[0].clientY
        };
      }, { passive: true });

      on(this, 'touchend', event => {
        if (
          !touch ||
          !event.changedTouches.length
        ) {
          return;
        }

        const dx =
          event.changedTouches[0].clientX -
          touch.x;

        const dy =
          event.changedTouches[0].clientY -
          touch.y;

        touch = null;

        if (
          Math.abs(dx) > 50 &&
          Math.abs(dx) >
            Math.abs(dy) * 1.4
        ) {
          suppressNextClick = true;

          show(
            index + (dx < 0 ? 1 : -1)
          );
        }
      }, { passive: true });

      on(this, 'touchcancel', () => {
        touch = null;
      }, { passive: true });

      /* ==================================================
         THEME EDITOR
         Seçilen slaytı göster ama autoplay'i KAPATMA.
      ================================================== */
      on(this, 'shopify:block:select', event => {
        const selected =
          slides.findIndex(
            slide =>
              slide.dataset.blockId ===
              event.detail.blockId
          );

        if (selected !== -1) {
          show(selected, false);
        }
      });

      /* ==================================================
         TAB VISIBILITY
      ================================================== */
      on(document, 'visibilitychange', () => {
        if (document.hidden) {
          stopClock();
        } else {
          startClock();
        }
      });

      /* ==================================================
         VIEWPORT
      ================================================== */
      const observer =
        'IntersectionObserver' in window
          ? new IntersectionObserver(
              entries => {
                visible =
                  entries[0].isIntersecting;

                if (visible) {
                  startClock();
                } else {
                  stopClock();
                }
              },
              { threshold: .1 }
            )
          : null;

      observer?.observe(this);

      this._cleanup = () => {
        stopClock();
        events.abort();
        observer?.disconnect();
        this.dataset.mchReady = 'false';
        this._cleanup = null;
      };

      show(index, false);
      startClock();
    }

    disconnectedCallback() {
      this._cleanup?.();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
